/**
 * @param token JWT token
 * @returns token claims in object
 */
export const parseJWTToken = (token: string): { unique_name: string[] } =>
  token ? JSON.parse(atob(token.split('.')[1])) : null;
